import {TmParsingError, TmParsingException} from "../../errors/Exceptions.js";
import {TmAlphabet} from "./TmAlphabet";


export default class TmParser {
    // parseStates, parseState
    // parseTransitionRelation
    // parseInputString

    /**
     * Creates TmAlphabet. Duplicate chars are not considered and will be added to alphabet only once.
     *
     * @param strChars {string} (not empty and not whitespaces-only) string with characters of alphabet,
     * possibly delimited by one or more spaces.
     * Whitespaces won't be considered as alphabet's chars.
     * @param strEmptyCellChar string with emptyCellChar. Must contain only ONE non-whitespace character.
     * Whitespaces won't be considered.
     *
     * @return {TmAlphabet}
     */
    static parseTmAlphabet(strChars, strEmptyCellChar){
        // parsing
        let chars = strChars
            .replace(/\s/g,'') // remove all whitespaces
            .split(''); // string[], each element is string with length=1
        let emptyCellChar = strEmptyCellChar.replace(/\s/g,'');

        // checks
        let errors = [];
        if(chars.length === 0){
            errors.push(new TmParsingError('alphabet', undefined, 'Alphabet can\'t be empty'));
        }
        if(emptyCellChar.length !== 1){
            errors.push(new TmParsingError('alphabet', undefined, 'Empty-cell char can\'t be empty'));
        }
        else{
            if(chars.length > 0 && !chars.includes(emptyCellChar)){
                errors.push(new TmParsingError('alphabet', undefined, 'Empty-cell char must be contained into alphabet chars'))
            }
        }

        if(errors.length > 0){
            throw new TmParsingException(errors, '');
        }

        return new TmAlphabet(chars, emptyCellChar);
    }


    /**
     * Parses array of chars. Duplicate chars are not considered and will be added to alphabet only once.
     *
     * @param strChars {string} (not empty and not whitespaces-only) string with characters of alphabet,
     * possibly delimited by one or more spaces.
     * Whitespaces won't be considered as alphabet's chars.
     *
     * @return {string[]}
     *
     * @throws {TmParsingException} when <code>strChars</code> does non contain any non-whitespace character
     */
    static parseTmAlphabetChars(strChars){
        // parsing
        let chars = strChars
            .replace(/\s/g,'') // remove all whitespaces
            .split(''); // string[], each element is string with length=1

        // checks
        let errors = [];
        if(chars.length === 0){
            errors.push(new TmParsingError('alphabet', undefined, 'Alphabet can\'t be empty'));

            throw new TmParsingException(errors, '');
        }

        return chars;
    }
}